import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import BlogsGenerator from './components/BlogsGenerator.js';
import Register from './components/Register.js';
import Login from './components/Login.js';
import BlogList from './components/BlogList.js';
import ModifyBlog from './components/ModifyBlog.js';
import Navbar from './components/navigationBar.js';
import Home from './components/Home.js';
import NotFound from './components/NotFound.js';


function App() {
  return (
    <Router>
      <Navbar />
      <div className="App">
        <Routes>
          <Route path="/" element={<Home/>} />
          <Route path="/register" element={<Register />} />
          <Route path="/login" element={<Login />} />
          <Route path="/blogs" element={<BlogsGenerator />} />
          <Route path="/blog-list" element={<BlogList />} />
          <Route path="/modify-blog" element={<ModifyBlog />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
